import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectedRoleInitialState {
  roleAdActing?: string;
}

const initialState: SelectedRoleInitialState = {
  roleAdActing: window.localStorage.getItem('roleAdActing') ?? undefined,
};

export const selectRoleSlice = createSlice({
  name: 'selectedRole',
  initialState,
  reducers: {
    setSelectRoleAdActing(state, action: PayloadAction<string>) {
      window.localStorage.setItem('roleAdActing', action.payload);
      state.roleAdActing = action.payload;
    },
  },
});

export const { setSelectRoleAdActing } = selectRoleSlice.actions;
